import {ChangeDetectionStrategy, Component, inject, input, InputSignal} from "@angular/core";
import {QrCodePageComponent} from "../qr-code-page/qr-code-page.component";
import {NavigationService} from "../../../navigation/navigation.service";
import {QrCodeComponent} from "../qr-code/qr-code.component";
import {ActivatableDirective} from '../../activatable.directive';

@Component({
    selector: "woa-qr-code-panel",
    templateUrl: "./qr-code-panel.component.html",
    styleUrl: "./qr-code-panel.component.scss",
    imports: [
        QrCodeComponent,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QrCodePanelComponent {
    private navigationService: NavigationService = inject(NavigationService);

    public readonly value: InputSignal<string> = input.required<string>();

    public readonly displayValue: InputSignal<string> = input<string>();
    public readonly message: InputSignal<string> = input<string>();

    public async expand(event?: Event): Promise<void> {
        event.stopPropagation();
        return QrCodePageComponent.showQrCode(this.navigationService, this.value(), this.message(), this.displayValue());
    }
}
